import profile1 from '../assets/profile1.png'
import profile2 from '../assets/profile2.png'

export const TestimonialsData = [
    {
        image : profile1,
        comment: "The products were delivered within 4 days and was carefully packed to avoid any damage.I am truly amazed by their service.",
        name: "Natasha"
    },
    {
        image : profile2,
        comment: "I was always afraid to use anything on my skin but I am happy that I trusted this brand for my skincare journey!..The products are amazing.",
        name: "Jhon Alex"
    },
    {
        image : profile1,
        comment: " The products were delivered within 4 days and was carefully packed to avoid any damage.I am truly amazed by their service.",
        name: "Aleena"
    },
    {
        image : profile2,
        comment: " I was always afraid to use anything on my skin but I am happy that I trusted this brand for my skincare journey!..The products are amazing.",
        name: "Parth Kalra"
    },
    {
        image : profile1,
        comment: " The products were delivered within 4 days and was carefully packed to avoid any damage.I am truly amazed by their service.",
        name: "Naina"
    },
    {
        image : profile2,
        comment: "I was always afraid to use anything on my skin but I am happy that I trusted this brand for my skincare journey!..The products are amazing .",
        name: "Alex Hormonzi"
    },
]